import React from "react";
import { CognitoHelper } from '../../Utilities/CognitoHelper';

export default function EmailVerification(props) {
    const checkVerification = () => {
        const cognitoHelper = new CognitoHelper()

        const user = cognitoHelper.getUser()

        console.log('cognitoHelper.getUser')
        console.log(user)

        if (user.getSignInUserSession().isValid()) {
            window.location.reload();
        }
  }

    const signOut = () => {
        const cognitoHelper = new CognitoHelper()

        cognitoHelper.signOut(function() {
            console.log("signed out")
        })
    };

    React.useEffect(() => {
        checkVerification()
    },[]);

    return (
        <div>
            <h3>
                We have sent you an email to verify your email address.
                Click the link in the email to verify your email and refresh this page to proceed to the site.
            </h3>
            <button onClick={checkVerification}>Check Verification</button>
            <button onClick={signOut}>Log Out</button>
        </div>
    );
}
